import { FrameStore, ModuleBase } from "@/modules/base";
import { LayerComponentBase } from '@/stellar-globe-components';
import { ConstellationLayer } from "@hscmap/stellar-globe";
import { CreateElement } from "vue";
import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import { store } from '@/store';

@Component
export class ConstellationLayerModule extends Mixins(ModuleBase) {
  get outlet() {
    return {
      overlayLayer: OverlayLayer,
    }
  }

  frameStore() {
    return {
      lang: ConstellationLayer.LANG.ENGLISH,
      show: true,
      names: false,
    }
  }
}

@Component
class OverlayLayer extends Vue {
  @Prop({ required: true })
  frameStore!: FrameStore<typeof ConstellationLayerModule>

  render(h: CreateElement) {
    if (this.frameStore.show) {
      return h(ConstellationLayerComponent, {
        props: {
          lang: this.frameStore.lang,
          showNames: this.frameStore.names,
        },
      })
    }
  }
}

@Component
export default class ConstellationLayerComponent extends LayerComponentBase<ConstellationLayer> {
  @Prop({ default: false })
  showNames!: boolean

  @Watch('showNames')
  onShowNamesChange() {
    this.layer.showNames = this.showNames
    this.globe.requestRefresh()
  }

  @Prop({ default: ConstellationLayer.LANG.ENGLISH })
  lang!: number
  @Watch('lang')
  onLangChange() {
    this.refreshLayer()
  }

  newLayer() {
    return new ConstellationLayer(true, this.showNames, this.lang)
  }
}
